import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { ArchitectureDiagram } from '../components/ArchitectureDiagram';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function HomeArchitecture() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4694" />
      <ArchitectureDiagram data-id="element-4695" />
      <HowItWorksConnections mode="how" data-id="element-4696" />
      <LivesInSlack data-id="element-4697" />
      <ComputerUse data-id="element-4698" />
      <CapabilityGrid data-id="element-4699" />
      <NarrativeSection data-id="element-4700" />
      <ToolComparison data-id="element-4701" />
      <WallOfLove data-id="element-4702" />
      <PricingSection data-id="element-4703" />
      <ClosingCTA data-id="element-4704" />
    </>;
}